import {AfterViewInit, ChangeDetectionStrategy, Component, OnInit, ViewChild} from '@angular/core';
import {NzMessageService} from "ng-zorro-antd";
import {ActivatedRoute} from "@angular/router";
import {DynamicWindowSingleService} from "./service/dynamic-window-single.service";
import {DynamicWindowSingleGetMetaInfoRequest} from "./service/model/dynamicWindowSingleGetMetaInfoRequest";
import {DynamicWindowSingleGetMetaInfoWin} from "./service/model/dynamicWindowSingleGetMetaInfoWin";
import { LcGridFormComponent } from '../lc-grid-form/lc-grid-form.component';
@Component({
  selector: 'lc-window-single',
  templateUrl: './lc-window-single.component.html',
  styleUrls: ['./lc-window-single.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
    providers:[DynamicWindowSingleService]
})
export class LcWindowSingleComponent implements OnInit,AfterViewInit {
    win?: DynamicWindowSingleGetMetaInfoWin={};
    windowId: string;
    windowCode: string;
   @ViewChild(LcGridFormComponent)
   dynamicComponentGridForm:LcGridFormComponent;
    constructor(
        private msg: NzMessageService,
        private dynamicSingleWindowService: DynamicWindowSingleService,
        private route: ActivatedRoute
    ) {

    }
   async ngOnInit() {
       this.windowId = this.route.snapshot.params.windowId;
       this.windowCode = this.route.snapshot.params.windowCode;
       const request: DynamicWindowSingleGetMetaInfoRequest = {};

       request.id = this.windowId;
       request.code=this.windowCode;
       const res = await this.dynamicSingleWindowService.getMetaInfo(request);
       this.win=res.data.win;
       const windowFormId = res.data.forms.find(f => {
           return f.windowFormType === 101;
       }).id;
       this.dynamicComponentGridForm.windowFormId = windowFormId;
   }

    ngAfterViewInit(): void {
    }
}
